import { Link } from "react-router-dom";
import { Instagram, Youtube, Heart } from "lucide-react";

const LINKS = [
  ["About Us", "/our-story"], ["FAQs", "/faq"], ["Shipping", "/faq"],
  ["Returns", "/faq"], ["Contact", "/contact"],
];

const TikTokIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

export default function Footer() {
  return (
    <footer className="border-t border-blush bg-white" data-testid="site-footer">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-6 px-6 py-7 lg:flex-row">
        <Link to="/" data-testid="footer-logo" aria-label="Bedtime Buddies home" className="shrink-0">
          <img src="/assets/logo.png" alt="Bedtime Buddies" className="h-14 w-auto" />
        </Link>

        <nav className="flex flex-wrap justify-center gap-x-9 gap-y-3" aria-label="Footer navigation">
          {LINKS.map(([label, to]) => (
            <Link key={label} to={to} data-testid={`footer-link-${label.toLowerCase().replace(/ /g, "-")}`}
              className="text-[15px] font-semibold text-navy/75 transition hover:text-pinkdeep">
              {label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-6">
          <div className="flex items-center gap-4">
            <a href="#" aria-label="Instagram" data-testid="footer-social-instagram" className="text-navy/70 transition hover:text-pinkdeep"><Instagram size={19} /></a>
            <a href="#" aria-label="TikTok" data-testid="footer-social-tiktok" className="text-navy/70 transition hover:text-pinkdeep"><TikTokIcon /></a>
            <a href="#" aria-label="YouTube" data-testid="footer-social-youtube" className="text-navy/70 transition hover:text-pinkdeep"><Youtube size={20} /></a>
          </div>
          <p className="flex items-center gap-2 text-right font-script text-2xl font-semibold leading-none text-navy/80">
            <span>Happier bedtimes.<br />Brighter tomorrows.</span>
            <Heart size={20} className="shrink-0 text-pinkdeep" strokeWidth={1.75} />
          </p>
        </div>
      </div>
      <div className="border-t border-blush/70">
        <p className="mx-auto max-w-7xl px-6 py-4 text-center text-xs text-navy/35">
          © 2026 Bedtime Buddies™. All rights reserved. · Not intended for infant sleep environments.
        </p>
      </div>
    </footer>
  );
}
